module.exports = __webpack_public_path__ + "img/apm-visa.7887dfd3.svg";